/* @flow */
import React from "react";

import { FormattedMessage } from "react-intl";

// I tried to make this more concrete, but failed.
type FlexibleAddress = {
    street: any;
    houseNumber: any;
    city: any;
    zipcode: any;
    buildingName?: any;
};

type Props = {
    address: FlexibleAddress | undefined | null;
    oneLine?: boolean;
    className?: string;
    children?: any; // for OrderHistorySubOrderDetail
};

/**
 * Renders addresses for different countries differently.
 */
class FormattedAddress extends React.Component<Props> {
    render() {
        const addressWithDefaults = Object.assign(
            { city: "", houseNumber: "", house2Num: "", zipcode: "", street: "", buildingName: "" },
            this.props.address || {}
        );
        return (
            <div className={this.props.className}>
                {!this.props.oneLine && (
                    <div>
                        <FormattedMessage id="EX_ADDRESS_TEMPLATE_LINE_ONE" values={addressWithDefaults} />
                    </div>
                )}
                {this.props.children}
                <div>
                    <FormattedMessage id="EX_ADDRESS_TEMPLATE_LINE_TWO" values={addressWithDefaults} />
                </div>
            </div>
        );
    }
}

export default FormattedAddress;
